export const hasAnnouncementText = (announcements = [], text = '') => {
  if (!text) {
    return false;
  }
  return announcements.some(announcement => announcement?.text === text);
};
